import React, { useState } from 'react'
import { Input, Button, message } from 'antd'

const PasswordGate = ({ children, correctPassword }) => {
  const [input, setInput] = useState('')
  const [authenticated, setAuthenticated] = useState(false)

  const handleSubmit = () => {
    if (input === correctPassword) {
      setAuthenticated(true)
    } else {
      message.error('Incorrect password')
    }
  }

  if (authenticated) return <>{children}</>

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f3f4f6'
    }}>
      <div style={{
        padding: '1.5rem',
        backgroundColor: 'white',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        borderRadius: '0.75rem'
      }}>
        <h2 style={{
          marginBottom: '1rem',
          fontSize: '1.125rem',
          fontWeight: '600'
        }}>
          Enter Password
        </h2>
        <Input.Password
          placeholder="Password"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onPressEnter={handleSubmit}
        />
        <Button 
          style={{ marginTop: '0.75rem' }}
          type="primary" 
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  )
}

export default PasswordGate
